var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articleBasicForm"},[_c('el-form-item',{attrs:{"label":"文章标题","required":""}},[_c('el-input',{attrs:{"placeholder":"必填：下发给 App 的文章标题，例如 Weekly fitness tips"},model:{value:(_vm.local.articleTitle),callback:function ($$v) {_vm.$set(_vm.local, "articleTitle", $$v)},expression:"local.articleTitle"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }